export default __webpack_public_path__ + "static/media/goods-top-banner.009215dc.jpg";